// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"def517ba","769":"3b2a4670"}[chunkId] + ".chunk.css";
};